import client from 'api/client';

export function getSOP(payload: unknown, appID: number, sopType: string = 'studentVisa') {
    return client.post(`/applications/${appID}/sop/generate-text?sop_type=${sopType}`, payload);
}

export function generateSOPDoc(payload: unknown, appID: number, sopType: string = 'studentVisa') {
    return client.post(`/applications/${appID}/sop/generate-doc?sop_type=${sopType}`, payload, {
        responseType: 'blob',
    });
}
